module.exports = __webpack_public_path__ + "static/media/1005269.20628d0e.jpg";